import React from 'react';
import { Box, Stack } from '@mui/material';
import styles from './styles';
import { useQuery } from '@tanstack/react-query';
import { conciergeAPI, RecentItem } from 'api/concierge';
import LoadingPlaceholder from 'components/common/loading-placeholder/LoadingPlaceholder';

export default function RecentChats({
    setActiveChat,
    setActiveChatRequest,
}: {
    setActiveChat: (id: number) => void;
    setActiveChatRequest: (request: string) => void;
}) {
    const { data, isLoading } = useQuery<RecentItem[]>({
        queryKey: ['conciergeRecentChats'],
        queryFn: () => conciergeAPI.getRecentChats(),
    });

    return (
        <Box sx={styles.container}>
            {isLoading && <LoadingPlaceholder />}
            <Stack sx={styles.chatList} spacing={1}>
                {data &&
                    data.map((item) => {
                        return (
                            <Box
                                sx={styles.chatItem}
                                onClick={() => {
                                    setActiveChat(item.conversation_ts);
                                    setActiveChatRequest(item.question);
                                }}
                            >
                                {item.question}
                            </Box>
                        );
                    })}
            </Stack>
        </Box>
    );
}
